import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddAttachment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 300 300",
	style: { enableBackground: "new 0 0 300 300" },
	xmlSpace: "preserve",
	width: "512px",
	height: "512px",
	className: "hovered-paths",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M149.996,0C67.157,0,0.001,67.161,0.001,149.997S67.157,300,149.996,300s150.003-67.163,150.003-150.003    S232.835,0,149.996,0z M221.999,133.598L123.43,232.16l0.005,0.005c-0.034,0.034-0.067,0.057-0.101,0.091l-0.604,0.604    l-0.031-0.034c-5.561,5.179-12.766,7.763-20.225,7.763c-8.896,0-18.124-3.628-25.264-10.769    c-6.349-6.344-10.156-14.54-10.719-23.078c-0.558-8.445,2.116-16.236,7.485-22.134l-0.054-0.054l97.41-97.41    c8.227-8.229,22.209-7.623,31.177,1.343c4.204,4.204,6.733,9.656,7.109,15.346c0.399,5.996-1.707,11.765-5.776,15.829    l-79.296,79.304l-11.005-11.002l79.301-79.307c1.162-1.162,1.32-2.703,1.248-3.787c-0.127-1.898-1.071-3.859-2.588-5.377    c-2.85-2.85-7.049-3.462-9.168-1.341l-96.455,96.453l0.003,0.003c-2.783,2.78-4.155,6.725-3.864,11.108    c0.316,4.77,2.516,9.423,6.196,13.103c7.306,7.304,18.14,8.364,24.18,2.376l98.608-98.6c4.593-4.596,6.865-11.056,6.393-18.186    c-0.498-7.519-3.942-14.825-9.692-20.575c-11.599-11.596-28.983-13.077-38.761-3.304l-81.579,81.576l-11.005-11.002l81.579-81.579    c15.842-15.839,43.103-14.361,60.768,3.302c8.421,8.416,13.468,19.265,14.218,30.55    C233.694,115.049,229.816,125.781,221.999,133.598z",
		className: "hovered-path active-path",
		fill: "#AA91D7"
	}) }) }) })
});
export default SvgAddAttachment;
